import React from 'react';
import { CircleCheck, ArrowRight } from 'lucide-react';
export const Solution = () => {
  return <section id="benefits" className="w-full py-16 bg-gray-50" data-id="element-169">
      <div className="container mx-auto px-4 md:px-8" data-id="element-170">
        <h2 className="text-3xl md:text-4xl font-bold mb-8 text-center text-gray-900" data-id="element-171">
          The Hidden Reason Why Nights Are the Worst
        </h2>
        <div className="flex flex-col md:flex-row items-center gap-8 mb-12" data-id="element-172">
          <div className="md:w-1/2 order-2 md:order-1" data-id="element-173">
            <div className="bg-white p-6 rounded-lg shadow-md mb-6" data-id="element-174">
              <p className="text-xl mb-4 italic text-gray-800" data-id="element-175">
                "All this time you thought it was just arthritis pain… but
                actually, it's{' '}
                <span className="font-bold" data-id="element-176">
                  what happens when you lie still at night
                </span>
                ."
              </p>
              <p className="text-lg text-gray-600" data-id="element-177">- Retired physiotherapist</p>
            </div>
            <h3 className="text-2xl font-bold mb-4 text-gray-900" data-id="element-178">
              Here's what he meant:
            </h3>
            <div className="space-y-4 mb-6" data-id="element-179">
              <div className="flex items-start gap-3" data-id="element-180">
                <div className="mt-1 flex-shrink-0" data-id="element-181">
                  <CircleCheck className="w-6 h-6 text-gray-700" data-id="element-182" />
                </div>
                <p className="text-xl text-gray-800" data-id="element-183">
                  During the day, you{' '}
                  <span className="font-bold" data-id="element-184">move around</span>. Your blood
                  keeps <span className="font-bold" data-id="element-185">circulating</span>. Your
                  joints stay{' '}
                  <span className="font-bold" data-id="element-186">flushed and loose</span>.
                </p>
              </div>
              <div className="flex items-start gap-3" data-id="element-187">
                <div className="mt-1 flex-shrink-0" data-id="element-188">
                  <CircleCheck className="w-6 h-6 text-gray-700" data-id="element-189" />
                </div>
                <p className="text-xl text-gray-800" data-id="element-190">
                  But at night, when you lie still…{' '}
                  <span className="font-bold" data-id="element-191">Circulation slows</span>.{' '}
                  <span className="font-bold" data-id="element-192">Fluid pools</span> in the joint.{' '}
                  <span className="font-bold" data-id="element-193">Pressure builds</span>.
                </p>
              </div>
            </div>
            <p className="text-xl font-bold mb-2 text-gray-900" data-id="element-194">
              That's why the burning starts at 2 AM.
            </p>
            <p className="text-xl font-bold mb-6 text-gray-900" data-id="element-195">
              That's why mornings feel like your knees are locked in cement.
            </p>
            <div className="bg-gray-100 p-6 rounded-lg border-l-4 border-gray-400" data-id="element-196">
              <p className="text-xl text-gray-800" data-id="element-197">
                And that's why{' '}
                <span className="font-bold" data-id="element-198">nothing I tried worked</span>.
                Because tablets, gels, and stiff braces only treated the pain{' '}
                <span className="font-bold" data-id="element-199">after it flared</span>.
              </p>
              <p className="text-xl font-bold mt-2 text-gray-900" data-id="element-200">
                They never stopped it from building in the first place.
              </p>
            </div>
          </div>
          <div className="md:w-1/2 order-1 md:order-2" data-id="element-201">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/4Wj7MRZD74tB64ZMYtWf3h/ChatGPT_Image_1_aug_2025%2C_22_55_17.png" alt="Illustration of knee pain and circulation issues" className="rounded-lg shadow-lg w-full" data-id="element-202" />
          </div>
        </div>
        <div className="bg-white p-8 rounded-lg shadow-md" data-id="element-203">
          <h3 className="text-2xl font-bold mb-6 text-center text-gray-900" data-id="element-204">
            The Simple Fix That Changed Everything
          </h3>
          {/* Product Showcase */}
          <div className="mb-8" data-id="element-205">
            <div className="flex flex-col md:flex-row gap-6 items-center" data-id="element-206">
              <div className="md:w-1/2" data-id="element-207">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/ijNgvgm5JFkTKoiQMrJ8kw/OC11_ProductImage_IMG2-1_a15a5d15-5a44-447b-8016-8d24db25bfce_%284%29.jpg" alt="Vital Relief Knee Sleeve on leg in bed" className="rounded-lg shadow-md w-full" data-id="element-208" />
              </div>
              <div className="md:w-1/2" data-id="element-209">
                <h4 className="text-xl font-bold mb-3 text-gray-900" data-id="element-210">
                  The Sleep-Through-The-Night Knee Sleeve
                </h4>
                <p className="text-xl mb-3 text-gray-800" data-id="element-211">
                  Unlike <span className="font-bold" data-id="element-212">bulky knee braces</span> or{' '}
                  <span className="font-bold" data-id="element-213">restrictive supports</span>, this
                  <span className="font-bold" data-id="element-214"> lightweight sleeve</span> is
                  specifically designed for{' '}
                  <span className="font-bold" data-id="element-215">nighttime wear</span>.
                </p>
                <p className="text-xl mb-3 text-gray-800" data-id="element-216">
                  The{' '}
                  <span className="font-bold" data-id="element-217">
                    breathable, compression fabric
                  </span>{' '}
                  gently supports your knee while{' '}
                  <span className="font-bold" data-id="element-218">
                    maintaining healthy circulation
                  </span>{' '}
                  - exactly what your joints need during those long hours of
                  sleep.
                </p>
                <div className="flex items-center justify-center mt-4" data-id="element-219">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/fiVPTXmAwsK5gxWR9QakRM/Vital_Relief_%2810%29.png" alt="Vital Relief Logo" className="h-12" data-id="element-220" />
                </div>
              </div>
            </div>
          </div>
          <div className="flex flex-col md:flex-row gap-8 items-center mt-10" data-id="element-221">
            <div className="md:w-1/2" data-id="element-222">
              <p className="text-xl mb-4 text-gray-800" data-id="element-223">
                After reading that,{' '}
                <span className="font-bold" data-id="element-224">everything clicked</span>.
              </p>
              <p className="text-xl mb-4 text-gray-800" data-id="element-225">
                I wasn't broken. I wasn't hopeless. I was missing{' '}
                <span className="font-bold" data-id="element-226">one crucial piece</span>.
              </p>
              <p className="text-xl mb-4 text-gray-800" data-id="element-227">And then I found it.</p>
              <p className="text-xl mb-4 font-bold text-gray-900" data-id="element-228">
                A breathable knee sleeve designed to gently keep circulation
                moving while you rest.
              </p>
              <p className="text-xl mb-4 text-gray-800" data-id="element-229">
                Not a bulky brace. Not copper or magnets. Not a pill.
              </p>
              <p className="text-xl text-gray-800" data-id="element-230">
                Just <span className="font-bold" data-id="element-231">gentle compression</span> that
                works <span className="font-bold" data-id="element-232">with your body</span>, not
                against it. Instead of choking off blood flow like those old
                neoprene supports…
              </p>
              <p className="text-xl mt-4 font-bold text-gray-900" data-id="element-233">
                It supported my knee in a way that kept fluid from pooling.
              </p>
              <p className="text-xl mt-2 font-bold text-gray-900" data-id="element-234">
                So the burning never built up.
              </p>
            </div>
            <div className="md:w-1/2" data-id="element-235"></div>
          </div>
          {/* Product Images Gallery */}
          <div className="mt-12" data-id="element-236">
            <h4 className="text-2xl font-bold mb-6 text-center text-gray-900" data-id="element-237">
              See Why People Are Calling This Their "Life-Changing Sleep
              Solution"
            </h4>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-238">
              <div className="rounded-lg overflow-hidden shadow-md" data-id="element-239">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/9x752jQiDJfcCXzot3pysm/ChatGPTImage30jun2025_10_26_29.png" alt="Woman in pajamas with knee sleeve" className="w-full h-64 object-cover" data-id="element-240" />
                <div className="p-4 bg-white" data-id="element-241">
                  <p className="text-lg text-gray-600 italic" data-id="element-242">
                    "<span className="font-bold" data-id="element-243">Finally sleeping</span> through
                    the night again"
                  </p>
                </div>
              </div>
              <div className="rounded-lg overflow-hidden shadow-md" data-id="element-244">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/fMNxQuRze88vCc2sD6xACM/ChatGPT_Image_24_jul_2025%2C_11_19_03.png" alt="Woman holding knee sleeve with thumbs up" className="w-full h-64 object-cover" data-id="element-245" />
                <div className="p-4 bg-white" data-id="element-246">
                  <p className="text-lg text-gray-600 italic" data-id="element-247">
                    "My knee pain used to{' '}
                    <span className="font-bold" data-id="element-248">wake me 3-4 times a night</span>
                    "
                  </p>
                </div>
              </div>
              <div className="rounded-lg overflow-hidden shadow-md" data-id="element-249">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/jqtLL2fpioK9eW7HfQZQLy/bonus4.png" alt="Doctor recommending knee sleeve" className="w-full h-64 object-cover" data-id="element-250" />
                <div className="p-4 bg-white" data-id="element-251">
                  <p className="text-lg text-gray-600 italic" data-id="element-252">
                    "<span className="font-bold" data-id="element-253">Recommended</span> by
                    healthcare professionals"
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="mt-8 flex justify-center" data-id="element-254">
            <a href="https://www.vitalrelief.co.uk/products/vital-relief™-sleep-through-the-night-knee-sleeve" className="inline-flex items-center bg-gray-800 hover:bg-gray-900 text-white font-bold py-4 px-8 rounded-lg transition duration-300 text-xl" data-id="element-255">
              <span className="mr-2" data-id="element-256">Learn how to try it yourself</span>
              <ArrowRight className="w-6 h-6" data-id="element-257" />
            </a>
          </div>
        </div>
      </div>
    </section>;
};